import React, { useState } from 'react'
import { Typography } from "@mui/material"
import { blueGrey } from "@mui/material/colors";
import { useEffect } from 'react';
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import { listViewerExamsLabFetchState, viewerExamsLabState } from 'src/Patient/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { userState } from 'src/store/user/userState';
import { activeTabReservationsPatientState } from '../state/atoms';
import CardExamLab from './CardExamLab'
const ListViewerExamsLab = () => {


    const { catchErrorApi } = useCatchErrorApi();
    const user = useRecoilValue(userState);
    const [viewerExamsLab, setViewerExamsLab] = useRecoilState(viewerExamsLabState);
    const [loading, setLoading] = useState(false)
    const activeTabReservationsPatient = useRecoilValue(activeTabReservationsPatientState);

    const viewerExamsLabCallback = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        try {
            if (activeTabReservationsPatient === "4") {
                setViewerExamsLab([])
                const examsLabFetch = await snapshot.getPromise(listViewerExamsLabFetchState(user.payload.uswRut));                
                let examenes = examsLabFetch.slice();
                examenes.sort((x,y) => { return parseInt(y.numeroOrden) - parseInt(x.numeroOrden) })
                setViewerExamsLab(examenes)
            }
        } catch (error) {
            setViewerExamsLab([]);
        } finally {
            setLoading(false)
        }
    }, [activeTabReservationsPatient]);

    useEffect(() => {
        viewerExamsLabCallback()
    }, [viewerExamsLabCallback])

    if (loading) return <HoursAvailableSkeleton />
    if (!loading && viewerExamsLab && viewerExamsLab.length === 0) return <EmptyCalendar text={"No tienes exámenes registrados"} />

    return (
        <div>
            <Typography textAlign={"start"} variant="h4" paddingY={1} color={blueGrey[600]}>
                RESULTADOS EXÁMENES LABORATORIO
            </Typography>
            {
                viewerExamsLab.map((el, index) => (
                    <CardExamLab cancelReservation={false} key={`${index}`} professional={el} />
                ))
            }
        </div>
    )

}

export default ListViewerExamsLab